import { Link, useLocation } from "react-router-dom";
import { Send } from "lucide-react";

export default function StickyCTA() {
  const { pathname } = useLocation();
  if (pathname === "/contact") return null;

  return (
    <div
      data-testid="sticky-mobile-cta-bar"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-navy/95 p-3 backdrop-blur-md md:hidden"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <Link
        to="/contact"
        data-testid="sticky-mobile-cta-button"
        className="flex min-h-12 w-full items-center justify-center gap-2 rounded-lg bg-cta font-display text-base font-bold text-white transition-colors hover:bg-cta-hover"
      >
        <Send className="h-4 w-4" aria-hidden="true" />
        Get My Free Preview
      </Link>
    </div>
  );
}
